import QueryKey from '@/enums/QueryKey';
import { useQuery } from '@tanstack/vue-query';
import axios from 'axios';

export function useTaskVoucherData(taskId?: number) {
    const { data: taskVouchers, isPending: isTaskVouchersPending } = useQuery({
        queryKey: [QueryKey.DASHBOARD_TASKS_VOUCHERS, taskId],
        queryFn: async () => {
            const { data } = await axios.post(route('v2.dashboard.tasks.vouchers.get'), {
                task_id: taskId,
            });
            return data;
        },
        placeholderData: [],
        enabled: !!taskId,
    });

    return {
        taskVouchers,
        isTaskVouchersPending,
    };
}
